import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div\n  class=\'font-size-small-1 margin-top-2 color-error\'\n  data-test-form-error-message\n  ...attributes\n>\n  {{@message}}\n</div>")